module.exports = __webpack_public_path__ + "img/xigongda.57cdc260.jpg";